module.exports = __webpack_public_path__ + "img/literature.3580f004.jpg";